import { Link } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';
import logo from '../assets/logo.svg';

const H_PAD = 'clamp(40px, 5.5vw, 80px)';

export default function Footer() {
  const isMobile = useIsMobile();

  return (
    <footer style={{
      background: '#0d0d0d', color: '#ccc',
      padding: isMobile ? `48px 24px 32px` : `60px ${H_PAD} 40px`,
      fontFamily: "'Josefin Sans', sans-serif",
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: isMobile ? '36px' : '40px', marginBottom: '48px' }}>
        {/* Brand */}
        <div>
          <img
            src={logo}
            alt="Norelio"
            style={{ height: '22px', display: 'block', marginBottom: '16px', filter: 'brightness(0) invert(1)' }}
          />
          <p style={{ fontSize: '12px', letterSpacing: '0.5px', lineHeight: '1.8', color: '#888', maxWidth: '220px' }}>
            Entre modernité et authenticité, chaque pièce est pensée pour sublimer votre style au quotidien. Parce que les détails font toute la différence.
          </p>
        </div>

        {/* Liens */}
        <div>
          <div style={{ fontSize: '10px', letterSpacing: '3px', textTransform: 'uppercase', color: '#fff', marginBottom: '20px' }}>
            Liens Rapides
          </div>
          {[['Accueil', '/'], ['Catalogue', '/catalogue'], ['Contact', '/contact']].map(([label, path]) => (
            <div key={path} style={{ marginBottom: '10px' }}>
              <Link to={path} style={{ color: '#888', textDecoration: 'none', fontSize: '12px', letterSpacing: '1px', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = '#888'}
              >{label}</Link>
            </div>
          ))}
        </div>

        {/* Info */}
        <div>
          <div style={{ fontSize: '10px', letterSpacing: '3px', textTransform: 'uppercase', color: '#fff', marginBottom: '20px' }}>
            Unicité & Créativité
          </div>
          <p style={{ fontSize: '12px', lineHeight: '1.8', color: '#888', letterSpacing: '0.5px' }}>
            Livraison au Maroc — paiement à la livraison disponible.
          </p>
          <p style={{ fontSize: '12px', color: '#888', marginTop: '12px', letterSpacing: '0.5px' }}>
            contact@norelio.com
          </p>
        </div>
      </div>

      <div style={{
        borderTop: '1px solid #222', paddingTop: '24px',
        display: 'flex', flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? '8px' : '0',
      }}>
        <span style={{ fontSize: '11px', color: '#555', letterSpacing: '1px' }}>© {new Date().getFullYear()} Norelio. Tous droits réservés.</span>
        <span style={{ fontSize: '11px', color: '#555', letterSpacing: '1px' }}>MAD · Maroc</span>
      </div>
    </footer>
  );
}
